<template>
  <div class="overviewList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        rowKey="returnNo"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'returnType'">
              {{ returnTypeListData[scope.row[item.field]] }}
            </span>
            <!--<span v-else-if="item.field === 'returnRealObject'">
              {{ returnRealObjectListData[scope.row[item.field]] }}
            </span>-->
            <!-- 退货方式 -->
            <span v-else-if="item.field === 'returnMethod'">
              {{ returnListData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'changeMethod'">
              {{ changeListData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'deliveryExpenseTaker'">
              {{ takerListData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'tradeType'">
              {{ tradeTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'accountingStatus'">{{
              statusListData[scope.row[item.field]]
            }}</span>
            <span v-else-if="item.field == 'isDirectDeliver'">
              <div v-if="scope.row.isDirectDeliver == '1'">
                {{ $t('addSupplierDelivery.option.direct') }}
              </div>
              <div v-if="scope.row.isDirectDeliver == '0'">
                {{ $t('addSupplierDelivery.option.notDirect') }}
              </div>
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import GOODS_API from '@/api/masterData/goods';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  import MASTER_API from '@/api/masterData/company.js';
  import API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  import DELIVERY_API from '@/api/logisticsCenter/transportOrder';
  import SALES_API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  // import { resolve, reject } from 'q';
  import tableMixins from '@/common/mixins/table.js';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import XEUtils from 'xe-utils';
  export default {
    name: 'overviewList',
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
      BatchConfirmDialog,
    },
    data() {
      return {
        returnTypeList: [
          { value: '1', label: this.$t('salePurchase.message.salesReturn') },
          { value: '0', label: this.$t('salePurchase.message.exchangeGoods') },
        ],
        returnTypeListData: [],
        returnRealObjectList: [
          { value: '1', label: this.$t('salePurchase.message.no') },
          { value: '0', label: this.$t('salePurchase.message.yes') },
        ],
        returnRealObjectListData: [],
        returnList: [],
        returnListData: [],
        statusListData: [],
        changeList: [],
        changeListData: [],
        takerList: [],
        takerListData: [],
        tradeTypeList: [],
        isDirectDeliverList: [
          { label: this.$t('addSupplierDelivery.option.direct'), value: '1' },
          { label: this.$t('addSupplierDelivery.option.notDirect'), value: '0' },
        ],
        tradeTypeData: [],
        menuButtonList: [],
        tableData: [],
        returnNos: [],
        load: false,
        query: {
          voucherNo: null,
          returnType: null,
          returnDepartmentCode: null,
          purchaseUnitNo: null,
          returnNo: null,
          // returnMinNo: null,
          // returnMaxNo: null,
          returnMoney: null,
          changeMethod: null,
          returnMethod: null,
          returnMoneyMinAmount: undefined,
          returnMoneyMaxAmount: undefined,
          returnRealObject: null,
          inboundStorageNo: null,
          returnSalesmanCode: null,
          ladingNo: null,
          // ladingMinNo: null,
          // ladingMaxNo: null,
          returnStatus: null,
          outboundStorageNo: null,
          returnOperatorCode: null,
          exchangeMinNo: null,
          exchangeMaxNo: null,
          createStartDate: null,
          createEndDate: null,
          deliveryExpenseTaker: null,
          predictExchangeStartDate: null,
          predictExchangeEndDate: null,
          predictReturnStartDate: null,
          predictReturnEndDate: null,
          actualSendQuantityMin: undefined,
          actualSendQuantityMax: undefined,
          nonInvoiceQuantity: null,
          nonInvoiceQuantityFlag: null,
          invoiceAmount: null,
          invoiceAmountFlag: null,
          tradeType: null,
          actualInboundQuantity: null,
          actualInboundQuantityFlag: null,
          isDirectDeliver: null,
          accountingStatus: null,
        },
        columnList: [],
        laccountingStatusOptions: [],
        requestStatusList: [
          { label: '审批中', value: 'ZT02' },
          { label: '已保存', value: 'ZT06' },
          { label: '已确认', value: 'ZT03' },
          { label: '已驳回', value: 'ZT05' },
          { label: '已审核通过', value: 'ZT07' },
          { label: '已冲销', value: 'ZT08' },
        ], //申请状态下拉列表
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: 50,
            fixed: 'left',
          },
          // {
          //   type: "seq",
          //   visible: true,
          //   width: "50",
          //   title: "overviewList.table.title"
          // },
          {
            field: 'gmtCreate',
            title: 'overviewList.table.gmtCreate',
            // width: 150,
            visible: true,
          },
          {
            field: 'returnNo',
            title: 'overviewList.table.returnNo',
            // width: 120,
            visible: true,
          },
          // {
          //   field: "returnType",
          //   title: "overviewList.table.returnType",
          //   width: 120,
          //   visible: true
          // },
          /*        {
          field: "returnRealObject",
          title: "overviewList.table.returnRealObject",
          // width: 120,
          visible: true
        },*/
          {
            field: 'ladingNo',
            title: 'overviewList.table.ladingNo',
            // width: 120,
            visible: true,
          },
          {
            field: 'purchaseUnitName',
            title: 'overviewList.table.purchaseUnitName',
            // width: 120,
            visible: true,
          },
          {
            field: 'returnStatusName',
            title: 'overviewList.table.returnStatusName',
            // width: 120,
            visible: true,
          },
          {
            field: 'isDirectDeliver',
            title: 'overviewList.table.isDirectDeliver',
            // width: 120,
            visible: true,
          },
          {
            field: 'nonInvoiceQuantityDetail',
            title: 'overviewList.table.nonInvoiceQuantity',
            // width: 120,
            visible: true,
          },
          {
            field: 'predictExchangeAddress',
            title: 'overviewList.table.predictExchangeAddress',
            // width: 120,
            visible: true,
          },
          {
            field: 'returnMoneyAmount',
            title: 'overviewList.table.returnMoneyAmount',
            // width: 120,
            format: 'formatAmountRound',
            visible: true,
          },
          {
            field: 'deliveryExpenseTaker',
            title: 'overviewList.table.deliveryExpenseTaker',
            // width: 120,
            visible: true,
          },
          {
            field: 'returnMethod',
            title: 'overviewList.table.returnMethod',
            // width: 120,
            visible: true,
          },
          // {
          //   field: "changeMethod",
          //   title: "overviewList.table.changeMethod",
          //   width: 120,
          //   visible: true
          // },
          // {
          //   field: "outboundStorageName",
          //   title: "overviewList.table.outboundStorageName",
          //   width: 120,
          //   visible: true
          // },
          {
            field: 'inboundStorageName',
            title: 'overviewList.table.inboundStorageName',
            // width: 120,
            visible: true,
          },
          {
            field: 'actualInboundQuantity',
            title: 'overviewList.table.actualInboundQuantity',
            // width: 120,
            visible: true,
          },
          // {
          //   field: "actualSendQuantity",
          //   title: "overviewList.table.actualSendQuantity",
          //   width: 120,
          //   visible: true
          // },
          {
            field: 'returnDepartmentName',
            title: 'overviewList.table.returnDepartmentName',
            // width: 120,
            visible: true,
          },
          {
            field: 'returnSalesmanName',
            title: 'overviewList.table.returnSalesmanName',
            // width: 120,
            visible: true,
          },
          {
            field: 'returnOperatorName',
            title: 'overviewList.table.returnOperatorName',
            // width: 120,
            visible: true,
          },
          {
            field: 'invoiceAmount',
            title: 'overviewList.table.invoiceAmount',
            // width: 120,
            format: 'formatAmountRound',
            visible: true,
          },
          {
            field: 'tradeType',
            title: 'overviewList.table.tradeType',
            // width: 120,
            visible: true,
          },
          {
            field: 'currencyName',
            title: 'salesBill.table.currencyName',
            // width: '150',
            visible: true,
          },
          {
            field: 'accountingStatus',
            title: 'salesBill.table.accountingStatus',
            // width: '150',
            visible: true,
          },
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          // 退换货类型
          // {
          //   prop: "returnType",
          //   name: this.$t("overviewList.search.returnType"),
          //   type: "select",
          //   placeholder: this.$t("overviewList.search.returnTypePlaceholder"),
          //   options: this.returnTypeList
          // },
          // 业务部门
          {
            prop: 'returnDepartmentCode',
            name: this.$t('overviewList.search.returnDepartmentCode'),
            type: 'treeSelect',
            apiUrl: MASTER_API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
            },
            clearable: false,
          },
          // 客户编号
          {
            prop: 'purchaseUnitNo',
            name: this.$t('overviewList.search.purchaseUnitNo'),
            type: 'searchTableSpec',
            searchType: 'customer',
            width: '800',
            isMultiple: true,
            extraData: {
              departmentCode: this.query.returnDepartmentCode,
            },
            placeholder: this.$t('overviewList.search.purchaseUnitNoPlaceholder'),
          },
          // 销售退货单号
          {
            prop: 'returnNo',
            name: this.$t('overviewList.search.returnMinNo'),
            type: 'input',
            maxlength: 32,
            placeholder: this.$t('overviewList.search.returnMinNoPlaceholder'),
          },
          // // 销售退货单号
          // {
          //   prop: "returnMaxNo",
          //   name: this.$t("overviewList.search.returnMaxNo"),
          //   type: "input",
          //   maxlength: 32,
          //   placeholder: this.$t("overviewList.search.returnMaxNoPlaceholder")
          // },
          // 是否退款，0是，1否
          {
            prop: 'returnMoney',
            name: this.$t('overviewList.search.returnMoney'),
            type: 'select',
            placeholder: this.$t('overviewList.search.returnMoneyPlaceholder'),
            options: this.returnRealObjectList,
          },
          // 换货方式（字典）
          // {
          //   prop: "changeMethod",
          //   name: this.$t("overviewList.search.changeMethod"),
          //   type: "select",
          //   placeholder: this.$t("overviewList.search.changeMethodPlaceholder"),
          //   options: this.changeList
          // },
          // 退货方式（字典）
          {
            prop: 'returnMethod',
            name: this.$t('overviewList.search.returnMethod'),
            type: 'select',
            placeholder: this.$t('overviewList.search.returnMethodPlaceholder'),
            options: this.returnList,
          },
          // 总金额
          {
            type: 'inputRange',
            prop: ['returnMoneyMinAmount', 'returnMoneyMaxAmount'],
            precision: 6,
            max: 99999999999999.99,
            name: this.$t('overviewList.search.returnMoneyAmount'),
          },
          // 是否实物退换,0是，1否
          /*       {
          prop: "returnRealObject",
          name: this.$t("overviewList.search.returnRealObject"),
          type: "select",
          placeholder: this.$t(
            "overviewList.search.returnRealObjectPlaceholder"
          ),
          options: this.returnRealObjectList
        },*/
          // 入库仓库编码
          {
            prop: 'inboundStorageNo',
            name: this.$t('overviewList.search.inboundStorageNo'),
            type: 'searchTableSpec',
            searchType: 'warehouse',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('overviewList.search.inboundStorageNoPlaceholder'),
          },
          // 业务员员工号
          {
            prop: 'returnSalesmanCode',
            name: this.$t('overviewList.search.returnSalesmanCode'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('overviewList.search.returnSalesmanCodePlaceholder'),
          },
          // 提单号
          {
            prop: 'ladingNo',
            name: this.$t('overviewList.search.ladingMinNo'),
            type: 'input',
            maxlength: 32,
            placeholder: this.$t('overviewList.search.ladingMinNoPlaceholder'),
          },
          // 提单号
          // {
          //   prop: "ladingMaxNo",
          //   name: this.$t("overviewList.search.ladingMaxNo"),
          //   type: "input",
          //   maxlength: 32,
          //   placeholder: this.$t("overviewList.search.ladingMaxNoPlaceholder")
          // },
          // 退换货状态
          {
            prop: 'returnStatus',
            name: this.$t('overviewList.search.returnStatus'),
            type: 'select',
            placeholder: this.$t('overviewList.search.returnStatusPlaceholder'),
            options: this.requestStatusList,
          },
          // 出库仓库编码
          // {
          //   prop: "outboundStorageNo",
          //   name: this.$t("overviewList.search.outboundStorageNo"),
          //   type: "searchTableSpec",
          //   searchType: "warehouse",
          //   width: "800",
          //   isMultiple: true,
          //   placeholder: this.$t(
          //     "overviewList.search.outboundStorageNoPlaceholder"
          //   )
          // },
          // 操作人员工号
          {
            prop: 'returnOperatorCode',
            name: this.$t('overviewList.search.returnOperatorCode'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('overviewList.search.returnOperatorCodePlaceholder'),
          },
          // 提单号
          // {
          //   prop: "exchangeMinNo",
          //   name: this.$t("overviewList.search.exchangeMinNo"),
          //   type: "input",
          //   placeholder: this.$t("overviewList.search.exchangeMinNoPlaceholder")
          // },
          // 提单号
          // {
          //   prop: "exchangeMaxNo",
          //   name: this.$t("overviewList.search.exchangeMaxNo"),
          //   type: "input",
          //   placeholder: this.$t("overviewList.search.exchangeMaxNoPlaceholder")
          // },
          {
            prop: 'createStartDate',
            name: this.$t('overviewList.search.createStartDate'),
            type: 'daterange',
          },
          // {
          //   prop: "createEndDate",
          //   name: this.$t("overviewList.search.createEndDate"),
          //   type: "endDaterangePicker"
          // },
          {
            prop: 'predictReturnStartDate',
            name: this.$t('overviewList.search.predictReturnStartDate'),
            type: 'daterange',
          },
          // {
          //   prop: "predictReturnEndDate",
          //   name: this.$t("overviewList.search.predictReturnEndDate"),
          //   type: "endDaterangePicker"
          // },
          // 运费承担
          {
            prop: 'deliveryExpenseTaker',
            name: this.$t('overviewList.search.deliveryExpenseTaker'),
            type: 'select',
            placeholder: this.$t('overviewList.search.deliveryExpenseTakerPlaceholder'),
            options: this.takerList,
          },
          // {
          //   prop: "predictExchangeStartDate",
          //   name: this.$t("overviewList.search.predictExchangeStartDate"),
          //   type: "startDaterangePicker"
          // },
          // {
          //   prop: "predictExchangeEndDate",
          //   name: this.$t("overviewList.search.predictExchangeEndDate"),
          //   type: "endDaterangePicker"
          // },
          // 实际入库数量
          {
            prop: ['actualInboundQuantityFlag', 'actualInboundQuantity'],
            name: this.$t('overviewList.search.actualInboundQuantity'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 32,
            options: [
              { value: '01', label: this.$t('overviewList.search.large') },
              { value: '02', label: this.$t('overviewList.search.small') },
              { value: '03', label: this.$t('overviewList.search.equal') },
              { value: '04', label: this.$t('overviewList.search.notEqual') },
            ],
            placeholder: this.$t('overviewList.search.actualInboundQuantityPlaceholder'),
          },
          // 实际入库数量比较标记
          // {
          //   prop: "actualInboundQuantityFlag",
          //   name: this.$t("overviewList.search.actualInboundQuantityFlag"),
          //   type: "select",
          //   placeholder: this.$t(
          //     "overviewList.search.actualInboundQuantityFlagPlaceholder"
          //   ),
          //   options: [
          //     { value: "01", label: this.$t("overviewList.search.large") },
          //     { value: "02", label: this.$t("overviewList.search.small") },
          //     { value: "03", label: this.$t("overviewList.search.equal") },
          //     { value: "04", label: this.$t("overviewList.search.notEqual") }
          //   ]
          // },
          // 未开票总数量
          {
            prop: ['nonInvoiceQuantityFlag', 'nonInvoiceQuantity'],
            name: this.$t('overviewList.search.nonInvoiceQuantity'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 32,
            options: [
              { value: '01', label: this.$t('overviewList.search.large') },
              { value: '02', label: this.$t('overviewList.search.small') },
              { value: '03', label: this.$t('overviewList.search.equal') },
              { value: '04', label: this.$t('overviewList.search.notEqual') },
            ],
            placeholder: this.$t('overviewList.search.nonInvoiceQuantityPlaceholder'),
          },
          // 未开票总数量比较标记
          // {
          //   prop: "nonInvoiceQuantityFlag",
          //   name: this.$t("overviewList.search.nonInvoiceQuantityFlag"),
          //   type: "select",
          //   placeholder: this.$t(
          //     "overviewList.search.nonInvoiceQuantityFlagPlaceholder"
          //   ),
          //   options: [
          //     { value: "01", label: this.$t("overviewList.search.large") },
          //     { value: "02", label: this.$t("overviewList.search.small") },
          //     { value: "03", label: this.$t("overviewList.search.equal") },
          //     { value: "04", label: this.$t("overviewList.search.notEqual") }
          //   ]
          // },
          // 已开金额
          {
            prop: ['invoiceAmountFlag', 'invoiceAmount'],
            name: this.$t('overviewList.search.invoiceAmount'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 32,
            options: [
              { value: '01', label: this.$t('overviewList.search.large') },
              { value: '02', label: this.$t('overviewList.search.small') },
              { value: '03', label: this.$t('overviewList.search.equal') },
              { value: '04', label: this.$t('overviewList.search.notEqual') },
            ],
            placeholder: this.$t('overviewList.search.invoiceAmountPlaceholder'),
          },
          // 未开票总数量比较标记
          // {
          //   prop: "invoiceAmountFlag",
          //   name: this.$t("overviewList.search.invoiceAmountFlag"),
          //   type: "select",
          //   placeholder: this.$t(
          //     "overviewList.search.invoiceAmountFlagPlaceholder"
          //   ),
          //   options: [
          //     { value: "01", label: this.$t("overviewList.search.large") },
          //     { value: "02", label: this.$t("overviewList.search.small") },
          //     { value: "03", label: this.$t("overviewList.search.equal") },
          //     { value: "04", label: this.$t("overviewList.search.notEqual") }
          //   ]
          // },
          // 贸易类型
          {
            prop: 'tradeType',
            name: this.$t('overviewList.search.tradeType'),
            type: 'select',
            placeholder: this.$t('overviewList.search.tradeTypePlaceholder'),
            options: this.tradeTypeList,
          },
          {
            prop: 'isDirectDeliver',
            name: this.$t('overviewList.search.isDirectDeliver'),
            type: 'select',
            placeholder: this.$t('overviewList.search.isDirectDeliverPlaceholder'),
            options: this.isDirectDeliverList,
          },
          {
            // 入账状态
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('paymentList.table.accountingStatus'),
            dictType: 'post_status',
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getDicData();
      this.getButtonList();
    },
    methods: {
      getDicData() {
        this.returnTypeList.map((item) => {
          this.returnTypeListData[item['value']] = item['label'];
        });
        this.returnRealObjectList.map((item) => {
          this.returnRealObjectListData[item['value']] = item['label'];
        });
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 退货方式
        this.$axios
          .post(API.DICT_LIST, { dictType: 'sales_return_method', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.returnList = res.data.data;
              this.returnList.map((item) => {
                this.returnListData[item['value']] = item['label'];
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        //入账状态 notgenerate-未生成,generated-已生成未入账,posted-已入账,postError-入账失败
        this.$axios
          .post(SALES_API.DICT_LIST, { dictType: 'post_status', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.laccountingStatusOptions = res.data.data;
              console.log(this.laccountingStatusOptions);
              this.laccountingStatusOptions.map((item) => {
                this.statusListData[item['value']] = item['label'];
                console.log(this.statusListData);
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        // 换货方式
        this.$axios.post(API.DICT_LIST, { dictType: 'change_method', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.changeList = res.data.data;
            this.changeList.map((item) => {
              this.changeListData[item['value']] = item['label'];
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
        // 运费承担
        this.$axios
          .post(API.DICT_LIST, { dictType: 'sales_freight_taker', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.takerList = res.data.data;
              this.takerList.map((item) => {
                this.takerListData[item['value']] = item['label'];
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        // 贸易类型
        this.$axios.post(API.DICT_LIST, { dictType: 'sale-trade-type', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.tradeTypeList = res.data.data;
            this.tradeTypeList.map((item) => {
              this.tradeTypeData[item['value']] = item['label'];
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },

      //获取数据
      getData() {
        //如果没有查询条件，提示信息
        // let count = Object.keys(this.query).length;
        // for (var key in this.$refs.siruiSearch.query) {
        //   if (
        //     this.$refs.siruiSearch.query[key] == null ||
        //     this.$refs.siruiSearch.query[key] == undefined ||
        //     this.$refs.siruiSearch.query[key] == ""
        //   ) {
        //     count--;
        //   }
        // }
        // if (count == 0) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t("salePurchase.nosearchError"),
        //     type: "error"
        //   });
        //   return;
        // }
        this.load = true;
        let query = {
          ...this.$refs.siruiSearch.query,
          pageSize: this.$refs.siruiTable.page.pageSize,
          pageNum: this.$refs.siruiTable.page.pageNum,
        };
        if (query.createStartDate) {
          query.createEndDate = query.createStartDate[1];
          query.createStartDate = query.createStartDate[0];
        }
        if (query.predictReturnStartDate) {
          query.predictReturnEndDate = query.predictReturnStartDate[1];
          query.predictReturnStartDate = query.predictReturnStartDate[0];
        }
        query = Object.assign(query, {
          // purchaseUnitNo: query.purchaseUnitNo
          //   ? query.purchaseUnitNo[0].partnerCode
          //   : null,
          purchaseUnitNo: this.handleData(query.purchaseUnitNo, 'partnerCode'), //客户
          inboundStorageNo: query.inboundStorageNo ? query.inboundStorageNo[0].storageCode : null,
          returnSalesmanCode: query.returnSalesmanCode ? query.returnSalesmanCode[0].id : null,
          outboundStorageNo: query.outboundStorageNo
            ? query.outboundStorageNo[0].storageCode
            : null,
          returnOperatorCode: query.returnOperatorCode ? query.returnOperatorCode[0].id : null,
        });
        this.$axios.post(API.LIST_ORDER_SALES_RETURN_BY_PAGE, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item.allPartnerCode);
            } else {
              list.push(item.partnerCode);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      chooseClick(type) {
        if (type == 'addReturn') {
          let path = {
            path: '/salesReturnAndExchange/returnAdd',
            name: 'returnAdd',
            meta: {
              keepAlive: true,
              title: this.$t('salePurchase.message.addSalesReturns'),
            },
            query: {
              type: '1', //退货
              isEdit: false,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'addChange') {
          let path = {
            path: '/salesReturnAndExchange/changeAdd',
            name: 'changeAdd',
            meta: {
              keepAlive: true,
              title: this.$t('salePurchase.message.salesReplacementAdd'),
            },
            query: {
              type: '0', //换货
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'transport') {
          // 生成运输单子
          if (this.multipleSelection.length == 1) {
            if (this.multipleSelection[0].returnStatus == 'ZT07') {
              const query = {
                otherNo: this.multipleSelection[0].returnNo,
                pageNum: 1,
                pageSize: 10,
              };
              this.$axios.post(DELIVERY_API.LIST_DELIVERY_PAGE, query).then((res) => {
                if (0 == res.data.code) {
                  if (res.data.data.list.length <= 0) {
                    this.makeTransport();
                  } else {
                    this.$message({
                      showClose: true,
                      message: this.$t('returnDetail.msg.transTip'),
                      type: 'error',
                    });
                  }
                }
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('returnDetail.msg.statusError'),
                type: 'error',
              });
            }
          } else {
            this.$message({
              showClose: true,
              message: this.$t('returnDetail.msg.selectTip'),
              type: 'error',
            });
          }
        } else if (type == 'separateInvoice') {
          //单独开票
          this.separateInvoice();
        } else if (type == 'combinedInvoice') {
          //合并1开票1
          this.combinedInvoice();
        } else if (type == 'batchSyncVoucher') {
          this.batchSyncVoucher(API.BATCH_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'batchSignSyncVoucher') {
          this.batchSyncVoucher(API.BATCH_SIGN_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'doBatchConfirm') {
          this.doBatchConfirm('AE_SO_MTL_RETURN', {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else {
          // 导出
          this.export();
        }
      },
      //合并开票
      combinedInvoice() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.lessOneInvoice'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.accountingStatus != 'posted')) {
          this.$message({
            showClose: true,
            message: '未入账的单据不能开票',
            type: 'error',
          });
          return;
        }
        let statusFlag = true; //默认状态都满足
        let numberFlag = true; //默认未开单总数量都满足
        let ruleFlag = true; //默认符合所有规则标记
        let ladingNoArr = [];
        let ladingNo = ''; //多个销售提单号
        selectedList.map((item) => {
          if (item.returnStatus != 'ZT03') {
            statusFlag = false;
          }
          if (!selectedList[0].nonInvoiceQuantity || selectedList[0].nonInvoiceQuantity < 0) {
            numberFlag = false;
          }
          if (
            item.returnCompanyCode != selectedList[0].returnCompanyCode ||
            item.customerNo != selectedList[0].customerNo ||
            item.ladingCurrency != selectedList[0].ladingCurrency ||
            item.tradeType != selectedList[0].tradeType
          ) {
            ruleFlag = false;
          }
          ladingNoArr.push(item.returnNo);
        });
        if (!statusFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyApprovalSeparately'),
            type: 'error',
          });
          return;
        }
        if (!numberFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyTotalGreaterSeparately'),
            type: 'error',
          });
          return;
        }
        if (!ruleFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.reselect'),
            type: 'error',
          });
          return;
        }
        ladingNo = ladingNoArr.join(',');
        this.$confirmAction('提示', this.$t('returnDetail.msg.sureInvoiceMsg'))
          .then(() => {
            this.gotoInvoice(ladingNo); //跳转销售开单页面
          })
          .catch(() => {});
      },
      //单独开票
      separateInvoice() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.lessOneInvoice'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.accountingStatus != 'posted')) {
          this.$message({
            showClose: true,
            message: '未入账的单据不能开票',
            type: 'error',
          });
          return;
        }
        let statusFlag = true; //默认状态都满足
        let numberFlag = true; //默认未开单总数量都满足
        selectedList.map((item) => {
          if (item.returnStatus != 'ZT03') {
            statusFlag = false;
          }
          item.nonInvoiceQuantityDetail = parseFloat(item.nonInvoiceQuantityDetail);
          if (!item.nonInvoiceQuantityDetail || item.nonInvoiceQuantityDetail < 0) {
            numberFlag = false;
          }
        });
        if (!statusFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyApprovalSeparately'),
            type: 'error',
          });
          return;
        }
        if (!numberFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyTotalGreaterSeparately'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction('提示', this.$t('returnDetail.msg.sureInvoiceMsg'))
          .then(() => {
            let uniqReturnList = XEUtils.uniqObjArr(selectedList, 'returnNo');
            if (uniqReturnList.length > 1) {
              let returnList = uniqReturnList.map((it) => it.returnNo);
              this.$axios.post(API.GET_SALESRETURN_ALONE, returnList).then((res) => {
                if (res.data.code === 0) {
                  this.gotoInvoiceList(selectedList[0].returnNo); //跳转销售开单页面
                } else {
                  this.$alert(res.data.msg);
                }
              });
            } else {
              this.gotoInvoice(selectedList[0].returnNo);
            }
          })
          .catch(() => {});
        // this.gotoInvoice(selectedList[0].returnNo); //跳转销售开单页面
      },
      //跳转到开票页面
      gotoInvoiceList(returnNo) {
        let path = {
          path: '/saleInvoice/list',
          name: 'saleInvoiceList',
          meta: {
            keepAlive: true,
            title: this.$t('salesBill.message.makeOutInvoice'),
          },
          query: { returnNo },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //跳转到开票页面
      gotoInvoice(returnNo) {
        let path = {
          path: '/saleInvoice/add',
          name: 'saleInvoiceAdd',
          meta: {
            keepAlive: true,
            title: this.$t('salesBill.message.makeOutInvoice'),
          },
          query: { returnNo },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      searchWarehouse(storageCode) {
        return new Promise((resolve, reject) => {
          const query = {
            storageCode,
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          };
          this.$axios.post(MASTER_API.GET_STORAGE_LIST, query).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              reject();
            }
          });
        });
      },
      // 生成运输单
      makeTransport() {
        let params = {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
          companyName: this.userInfo.companyName,
          departmentName: this.userInfo.departmentName,
          deliveryStatus: '1',
          salesmanNo: this.multipleSelection[0].returnSalesmanCode,
          salesmanName: this.multipleSelection[0].returnSalesmanName,
          deliveryDepartment: this.multipleSelection[0].departmentName,
          otherNo: this.multipleSelection[0].returnNo,
          deliveryType: '4', //运输类型为其他
          pickupStorageAddress: this.multipleSelection[0].deliveryAddress,
          shiptoStorageName: this.multipleSelection[0].inboundStorageName,
          shiptoStorageAddress: '',
          deliveryQuantity: this.multipleSelection[0].totalExchangeQuantity,
          deliveryMethod: this.multipleSelection[0].deliveryMethod,
          otherExpenseType: this.multipleSelection[0].inboundExpenseTaker == 'CD01' ? 'QTFY02' : '',
          otherExpense:
            this.multipleSelection[0].inboundExpenseTaker == 'CD01'
              ? this.multipleSelection[0].inboundExpenseAmount
              : '',
          shiptoMark: this.multipleSelection[0].mark,
        };
        let deliveryDetailStr = [];
        const query = {
          returnType: this.multipleSelection[0].returnType,
          returnNo: this.multipleSelection[0].returnNo,
        };
        this.$axios.get(API.GET_ORDER_SALES_RETURN, query).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.orderSalesReturnDetails.length) {
              res.data.data.orderSalesReturnDetails.map((item) => {
                let itemData = {
                  otherNo: item.returnDetailNo,
                  productName: item.productDesc,
                  deliveryQuantity: item.returnQuantity,
                  contractUnit: item.unit,
                };
                deliveryDetailStr.push(JSON.stringify(itemData));
              });
              params.deliveryDetailStr = '[' + deliveryDetailStr.join(',') + ']';
            } else {
              params.deliveryDetailStr = '[]';
            }
            if (this.multipleSelection[0].inboundStorageNo) {
              Promise.resolve(
                this.searchWarehouse(this.multipleSelection[0].inboundStorageNo)
              ).then((res) => {
                params.shiptoStorageAddress = res[0].storageAddress;
                this.makeData(params);
              });
            } else {
              this.makeData(params);
            }
          }
        });
      },
      makeData(params) {
        this.$axios.post(DELIVERY_API.SAVE_DELIVERY, params).then((res) => {
          if (res.data.code == 0) {
            this.getData();
            this.$message({
              showClose: true,
              message: this.$t('returnDetail.msg.transSuccess'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('returnDetail.msg.transFailed'),
              type: 'error',
            });
          }
        });
      },
      // 双击进入编辑
      dblclickEvent(tableRow) {
        let path;
        if (tableRow.row.returnType == 1) {
          path = {
            path: '/salesReturnAndExchange/returnEdit',
            name: 'returnEdit',
            meta: {
              keepAlive: false,
              title: this.$t('salePurchase.message.editSalesReturns'),
            },
            query: {
              type: '1', //退货
              isEdit: true,
              returnNo: tableRow.row.returnNo,
            },
          };
        } else {
          path = {
            path: '/salesReturnAndExchange/changeEdit',
            name: 'changeEdit',
            meta: {
              keepAlive: false,
              title: this.$t('salePurchase.message.salesReplacementEditor'),
            },
            query: {
              type: '0', //换货
              isEdit: true,
              returnNo: tableRow.row.returnNo,
            },
          };
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },

      export() {
        let returnNos = [];
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const tableColumn = this.$refs.siruiTable.getTableColumn();
        const showColumns = [];
        tableColumn.visibleColumn.forEach((item) => {
          if (item.property) {
            showColumns.push({ prop: item.property, label: item.title });
          }
        });
        selectedList.map((item) => {
          returnNos.push(item.returnNo);
        });
        this.multipleSelection.map((item) => {
          returnNos.push(item.returnNo);
        });
        let query = {
          ...this.$refs.siruiSearch.query,
          columns: JSON.stringify(showColumns),
          returnNos,
        };
        // 导出
        this.$axios.post(API.EXPORT_ORDER_SALES_RETURN_SELECT_COLUMN, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            window.location.href = res.data.data;
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
    },
  };
</script>
